module.exports = __webpack_public_path__ + "static/img/case2.d7c0961.jpg";